const encodeBlobToBase64 = async (blob) => {
  const reader = new FileReader();

  return await new Promise((resolve, reject) => {
    reader.onerror = () => {
      reject(new Error('Failed to encode upload part payload.'));
    };

    reader.onload = () => {
      const result = String(reader.result || '');
      const commaIndex = result.indexOf(',');
      const base64 = commaIndex >= 0 ? result.slice(commaIndex + 1) : result;

      if (!base64) {
        reject(new Error('Upload part payload encoding is empty.'));
        return;
      }

      resolve(base64);
    };

    reader.readAsDataURL(blob);
  });
};

export default encodeBlobToBase64;
